var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 8.00003C8.23386 8.00049 8.4603 7.91911 8.64021 7.77003L14.6402 2.77003C14.8444 2.60029 14.9729 2.35638 14.9972 2.09196C15.0216 1.82753 14.94 1.56425 14.7702 1.36003C14.6005 1.15581 14.3566 1.02739 14.0921 1.00301C13.8277 0.978631 13.5644 1.06029 13.3602 1.23003L8.00021 5.71003L2.64021 1.39003C2.53792 1.30697 2.42023 1.24493 2.29389 1.2075C2.16755 1.17007 2.03506 1.15798 1.90403 1.17192C1.773 1.18586 1.64602 1.22555 1.53038 1.28873C1.41475 1.3519 1.31273 1.4373 1.23021 1.54003C1.13863 1.64285 1.06927 1.76348 1.02648 1.89435C0.983688 2.02523 0.968386 2.16353 0.981528 2.30059C0.994671 2.43765 1.03598 2.57053 1.10286 2.69088C1.16974 2.81124 1.26076 2.91649 1.37021 3.00003L7.37021 7.83003C7.5553 7.95555 7.77711 8.0154 8.00021 8.00003Z",
    fill: "#3F4857"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_down.0972eb9f.svg";
export { ForwardRef as ReactComponent };